import axios from 'axios';
import { toast } from 'react-toastify';
import {
  APP_SETTING_CYPHER_TEXT_BEGIN,
  APP_SETTING_CYPHER_TEXT_SUCCESS,
  APP_SETTING_CYPHER_TEXT_FAILURE,
  APP_SETTING_CYPHER_TEXT_DISMISS_ERROR,
} from './constants';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { getCookie, updateUserIpInCookie } from '../../../common/utils/api_utils';

export function cypherText(args = {}) {
  return async (dispatch) => {
    dispatch({
      type: APP_SETTING_CYPHER_TEXT_BEGIN,
    });
    const { projectId, version } = args;
    const userIp = getCookie('userIp') || (await updateUserIpInCookie());
    const header = builderSurfaceJsonContentHeader(projectId, userIp);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/cypher/text`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200) {
            if (res.data.success == true) {
              dispatch({
                type: APP_SETTING_CYPHER_TEXT_SUCCESS,
                data: res.data.data,
              });
              resolve(res.data.data);
            } else {
              dispatch({
                type: APP_SETTING_CYPHER_TEXT_SUCCESS,
                data: res.data.message,
              });
              resolve(res.data.message);
            }
          } else {
            dispatch({
              type: APP_SETTING_CYPHER_TEXT_SUCCESS,
              data: '',
            });
            resolve('');
          }
        },
        (err) => {
          dispatch({
            type: APP_SETTING_CYPHER_TEXT_FAILURE,
            data: { error: err },
          });
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCypherTextError() {
  return {
    type: APP_SETTING_CYPHER_TEXT_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_CYPHER_TEXT_BEGIN:
      return {
        ...state,
        cypherTextPending: true,
        cypherTextError: null,
      };

    case APP_SETTING_CYPHER_TEXT_SUCCESS:
      return {
        ...state,
        cypherTextPending: false,
        cypherTextError: null,
      };

    case APP_SETTING_CYPHER_TEXT_FAILURE:
      return {
        ...state,
        cypherTextPending: false,
        cypherTextError: action.data.error,
      };

    case APP_SETTING_CYPHER_TEXT_DISMISS_ERROR:
      return {
        ...state,
        cypherTextError: null,
      };

    default:
      return state;
  }
}
